import {generatePath} from './generatePath';

export function front_public_ajax_user_info() {
  return generatePath(`/_user-info`);
}
